export default {
  '基础信息':'Basic Information',
  '赛事名称':'Event Name',
  '请输入赛事名称':'Please enter event name',
  '副标题':'Subtitle',
  '请输入活动副标题':'Please enter event subtitle',
  '封面':'Cover',
  '封面图片':'Cover Image',
  '请上传比例为':'Please upload a 1:1 ratio PNG/JPG image under 2MB',
  '周期':'Period',
  '至':'to',
  '在活动周期内参赛即可':'Participation is allowed during the event period',
  '级别':'Level',
  '请输入自定义级别':'Enter custom level',
  '说明':'Description',
  '选择范围':'Selection Range',
  '对齐方式':'Alignment',
  '图片':'Image',
  '视频':'Video',
  '链接':'Link',
  '表格':'Table',
  '请选择封面':'Select cover',
  '请选择周期':'Select period',
  '请选择级别':'Select level',
  '排行规则':'Ranking Rules',
  '运动项目':'Sport Items',
  '增加项目':'Add Item',
  '选择项目':'Select Item',
  '运动方式':'Exercise Mode',
  '支持特殊项目':'Support Special Items',
  '强度':'Intensity',
  '项目名':'Item Name',
  '运动强度':'Exercise Intensity',
  '确认要删除运动项目{sportSkuName}吗':'Confirm to delete sport item {sportSkuName}',
  '请选择运动项目':'Select a sport item',
  '请填写运动强度':'Enter exercise intensity',
  '运动强度填写错误':'Invalid exercise intensity',
  '请填写运动强度':'Enter exercise intensity',
  '请选择排行规则':'Select ranking rules',
  '运动项目不能为空':'Sport item cannot be empty',
  '编辑项目':'Edit Item',
  '新增项目':'Add Item',
  '赛事保存成功！':'Event saved successfully!',
  '编辑赛事':'Edit Event',
  '查看赛事':'View Event',
  '新增赛事':'Add Event',
  '填写基本信息':'Fill Basic Information',
  '配置运动项目':'Configure Sport Items',
  '赛事列表':'Event List',
  '标题、参与':'Title, Participating/Publishing Organization Fuzzy Search',
  '发布赛事':'Publish Event',
  '赛事封面':'Event Cover',
  '提前结束':'Early Termination',
  '标题':'Title',
  '赛事周期':'Event Period',
  '领域':'Category',
  '发布机构':'Publishing Organization',
  '发布人':'Publisher',
  '确认要删除{name}':'Confirm to delete {name}',
  '删除后，无法查看该赛事！':'Deleted events cannot be viewed!',
  '确认要提前结束{name}':'Confirm to terminate early {name}',
  '结束后，用户将不能继续参赛！':'Users cannot participate after termination!',
  '提前终止成功！':'Early termination succeeded!',
  '领域':'Category',
  '请选择领域':'Select category',
  '选择赛事类型':'Select Event Type',
  '闯关挑战赛':'Adventure Challenge',
  '学生可完成不同关卡，同时记录学生累积成绩及团队积分的比赛':'Students complete stages while accumulating scores and team points',
  '竞技排名赛':'Competitive Ranking',
  '记录学生单个运动项目最佳个人成绩的比赛':'Records students\' best individual scores in single sport items',
  '赛事':'Event',
  '标题':'Title'
}